export default __webpack_public_path__ + "static/media/final-step-bg-mobile.6cc584d6.webp";